import { render } from "./FiltterView.vue?vue&type=template&id=4c94345f&scoped=true"
import script from "./FiltterView.vue?vue&type=script&lang=js"
export * from "./FiltterView.vue?vue&type=script&lang=js"

import "./FiltterView.vue?vue&type=style&index=0&id=4c94345f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c94345f"]])

export default __exports__